const GoogleMapPreview = ({ lat, lng, zoom = 15 }) => {
    // Pastikan koordinat ada sebelum me-render
    if (!lat || !lng) {
      return (
        <div className="w-full h-full min-h-[250px] bg-gray-100 flex items-center justify-center rounded-xl border border-gray-200">
          <p className="text-gray-400 text-xs">Koordinat tidak tersedia</p>
        </div>
      );
    }
  
    // Menggunakan Embed URL resmi Google Maps
    // q=${lat},${lng} akan menempatkan pin tepat di koordinat tersebut
    const mapUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;
  
    return (
      <div className="w-full h-full min-h-[250px] rounded-xl overflow-hidden border border-gray-100">
        <iframe
          title="Google Maps"
          src={mapUrl}
          className="w-full h-full"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    );
  };
  
  export default GoogleMapPreview;